import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

import classes from './block-tokens.module.css';

export interface BlockErrorProps {
  blockType: string;
  outputDatasetRef?: string;
  message: string;
  maxLength?: number;
}

/**
 * Renders an error state with consistent subtle styling.
 * Uses gray colors to avoid alarming the user while clearly indicating an issue.
 */
export function BlockError({ blockType, outputDatasetRef, message, maxLength = 1000 }: BlockErrorProps) {
  const title = `Failed to render ${blockType}${outputDatasetRef ? ` for "${outputDatasetRef}"` : ''}`;
  const truncatedMessage = message.length > maxLength ? `${message.slice(0, maxLength)}...` : message;

  return (
    <Alert className={classes.alertBlockError} icon={<IconAlertCircle size={16} />} title={title} variant="transparent">
      <div className={classes.blockErrorMessage}>{truncatedMessage}</div>
    </Alert>
  );
}
